import { COVERGO_SAAS_DEV } from "../consts.js"
import { COVERGO_ASIA_QA } from "../consts.js"
import { COVERGO_EU_UAT } from "../consts.js"
import { COVERGO_EU_PROD } from "../consts.js"

export const simplyhealth = {
	"simplyhealth-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "simplyhealth_dev",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
	}
}

export const simplyhealth_qa = {
	"simplyhealth-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "simplyhealth_qa",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_QA,
	},
}

export const simplyhealth_uat = {
	"simplyhealth-studio.uat.eu.covergo.cloud": {
		appConfig: {
			tenantId: "simplyhealth_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_EU_UAT,
	},
}

export const simplyhealth_prod = {
	"simplyhealth-studio.eu.covergo.com": {
		appConfig: {
			tenantId: "simplyhealth_prod",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_EU_PROD,
		fileSystem: {
			bucketName: "covergo-euce1-prod-simplyhealth",
		},
	},
}
